import React, { useState } from 'react';
import { UserRole, ProfileType, DateFilter } from '../types/commission';
import { FilterBar } from './FilterBar';
import { CommissionGrid } from './CommissionGrid';
import { SummaryMetrics } from './SummaryMetrics';
import { SearchBar } from './SearchBar';
import { RoleSwitcher } from './RoleSwitcher';
import { useCommissionData } from '../hooks/useCommissionData';
import { LayoutDashboard } from 'lucide-react';
interface CommissionDashboardProps {
  currentRole: UserRole;
  onRoleChange: (role: UserRole) => void;
}
export function CommissionDashboard({
  currentRole,
  onRoleChange
}: CommissionDashboardProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedProfiles, setSelectedProfiles] = useState<ProfileType[]>(['Loan Officer', 'Sales Team Leader', 'Division Leader']);
  const [dateFilter, setDateFilter] = useState<DateFilter>('This Month');
  const filteredData = useCommissionData(currentRole, searchQuery, selectedProfiles, dateFilter);
  return <div className="flex flex-col h-screen bg-slate-50 overflow-hidden font-sans text-slate-900" data-id="element-68">
      {/* Top Header */}
      <header className="bg-white border-b border-slate-200 px-8 py-4 flex justify-between items-center shrink-0 z-20 relative" data-id="element-69">
        <div className="flex items-center gap-3" data-id="element-70">
          <div className="bg-blue-600 p-2 rounded-lg text-white shadow-sm" data-id="element-71">
            <LayoutDashboard size={20} data-id="element-72" />
          </div>
          <div data-id="element-73">
            <h1 className="text-xl font-bold text-slate-900" data-id="element-74">
              Commissions Manager
            </h1>
            <p className="text-xs text-slate-500" data-id="element-75">
              Tier Tracking & Commission Management
            </p>
          </div>
        </div>

        <div className="flex items-center gap-4" data-id="element-76">
          <div className="text-xs text-slate-400 uppercase tracking-wider font-semibold" data-id="element-77">
            Viewing as:
          </div>
          <RoleSwitcher currentRole={currentRole} onRoleChange={onRoleChange} data-id="element-78" />
        </div>
      </header>

      {/* Filter Bar */}
      <FilterBar role={currentRole} selectedProfiles={selectedProfiles} onProfileChange={setSelectedProfiles} dateFilter={dateFilter} onDateFilterChange={setDateFilter} data-id="element-79" />

      {/* Main Content Area */}
      <main className="flex-1 overflow-y-auto p-8" data-id="element-80">
        <div className="max-w-7xl mx-auto" data-id="element-81">
          {/* Summary Metrics */}
          <SummaryMetrics data={filteredData} data-id="element-82" />

          {/* Search Bar - Only visible for Admin */}
          {currentRole === 'System Administrator' && <div className="w-full max-w-md mb-6" data-id="element-83">
              <SearchBar value={searchQuery} onChange={setSearchQuery} data-id="element-84" />
            </div>}

          {/* Data Grid */}
          <CommissionGrid data={filteredData} data-id="element-85" />
        </div>
      </main>
    </div>;
}